import React from 'react';
export default function TypeTalkshow({handleTypeTalkshow}) {
  return (
    <button key={"type-Talkshow"} className="type-Talkshow" onClick={handleTypeTalkshow}>
    {" "}
    Talkshow{" "} 
  </button>
  );
};